/**
 * @generated SignedSource<<5de98a8cbc92d679ff18504a35b0eacf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleComponent_team$data = {
  readonly color: string | null;
  readonly dailySchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
      readonly startAt: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion" | "useNowIndexes_teamScheduleEventOccasion" | "useTeamScheduleLayout_teamScheduleEventOccasion">;
    }>;
    readonly id: string;
    readonly isActive: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule" | "TeamScheduleSectionHeader_teamSchedule">;
  };
  readonly monthlySchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion" | "useTeamScheduleLayout_teamScheduleEventOccasion">;
    }>;
    readonly id: string;
    readonly isActive: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule" | "TeamScheduleSectionHeader_teamSchedule">;
  };
  readonly prevDailySchedule: {
    readonly id: string;
    readonly notCompletedCount: number;
  };
  readonly prevMonthlySchedule: {
    readonly id: string;
    readonly notCompletedCount: number;
  };
  readonly prevWeeklySchedule: {
    readonly id: string;
    readonly notCompletedCount: number;
  };
  readonly weeklySchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion" | "useTeamScheduleLayout_teamScheduleEventOccasion">;
    }>;
    readonly id: string;
    readonly isActive: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleSectionHeaderSummary_teamSchedule" | "TeamScheduleSectionHeader_teamSchedule">;
  };
  readonly " $fragmentType": "TeamScheduleComponent_team";
};
export type TeamScheduleComponent_team$key = {
  readonly " $data"?: TeamScheduleComponent_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleComponent_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "freq",
  "value": "DAILY"
},
v1 = {
  "kind": "Literal",
  "name": "movePeriod",
  "value": -1
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "notCompletedCount",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v6 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "useTeamScheduleLayout_teamScheduleEventOccasion"
},
v7 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleListItem_TeamScheduleEventOccasion"
},
v8 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleSectionHeaderSummary_teamSchedule"
},
v9 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleSectionHeader_teamSchedule"
},
v10 = {
  "kind": "Literal",
  "name": "freq",
  "value": "WEEKLY"
},
v11 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": null,
  "kind": "LinkedField",
  "name": "events",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": "events(includeInlineRoutines:true)"
},
v12 = {
  "kind": "Literal",
  "name": "freq",
  "value": "MONTHLY"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleComponent_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": "prevDailySchedule",
      "args": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"DAILY\",movePeriod:-1)"
    },
    {
      "alias": "dailySchedule",
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "events",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            (v6/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useNowIndexes_teamScheduleEventOccasion"
            },
            (v7/*: any*/)
          ],
          "storageKey": "events(includeInlineRoutines:true)"
        },
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": "currentTeamSchedule(freq:\"DAILY\")"
    },
    {
      "alias": "prevWeeklySchedule",
      "args": [
        (v10/*: any*/),
        (v1/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"WEEKLY\",movePeriod:-1)"
    },
    {
      "alias": "weeklySchedule",
      "args": [
        (v10/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v4/*: any*/),
        (v11/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": "currentTeamSchedule(freq:\"WEEKLY\")"
    },
    {
      "alias": "prevMonthlySchedule",
      "args": [
        (v12/*: any*/),
        (v1/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "currentTeamSchedule(freq:\"MONTHLY\",movePeriod:-1)"
    },
    {
      "alias": "monthlySchedule",
      "args": [
        (v12/*: any*/)
      ],
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "currentTeamSchedule",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v4/*: any*/),
        (v11/*: any*/),
        (v9/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": "currentTeamSchedule(freq:\"MONTHLY\")"
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "107c86e3c62fc62316e71bf35876bedf";

export default node;
